/**
 * Task V: customer subscriptions (recurring billing via the shop's Stripe account) — owner plans, POS selling,
 * subscriber list / detail, report. One row per key: [key, English, 中文]. Malay falls back to English.
 */
const ROWS = [
  ["tv.nav", "Subscriptions", "订阅"],
  ["tv.page.sub", "Recurring plans billed automatically by Stripe every period — predictable cash flow, no chasing payments.", "顾客按期自动扣款的订阅计划 —— 现金流可预期，无需追款。"],
  ["tv.tab.subscribers", "Subscribers", "订阅会员"],
  ["tv.tab.plans", "Plans", "订阅计划"],
  ["tv.tab.report", "Report", "报表"],
  ["tv.sell", "Sell a subscription", "销售订阅"],
  ["tv.f.live", "Active", "进行中"],
  ["tv.f.past_due", "Payment failed", "扣款失败"],
  ["tv.f.ending", "Ending", "即将结束"],
  ["tv.f.all", "All", "全部"],
  ["tv.st.incomplete", "Waiting for card", "等待绑卡"],
  ["tv.st.trialing", "Free trial", "试用中"],
  ["tv.st.active", "Active", "生效中"],
  ["tv.st.past_due", "Payment failed", "扣款失败"],
  ["tv.st.unpaid", "Unpaid", "未付款"],
  ["tv.st.paused", "Paused", "已暂停"],
  ["tv.st.canceled", "Ended", "已结束"],
  ["tv.st.incomplete_expired", "Not completed", "未完成"],
  ["tv.col.customer", "Customer", "顾客"],
  ["tv.col.plan", "Plan", "计划"],
  ["tv.col.status", "Status", "状态"],
  ["tv.col.price", "Price", "价格"],
  ["tv.col.next", "Next billing", "下次扣款"],
  ["tv.col.card", "Card", "银行卡"],
  ["tv.per.week", "{price} / week", "{price} / 周"],
  ["tv.per.month", "{price} / month", "{price} / 月"],
  ["tv.per.year", "{price} / year", "{price} / 年"],
  ["tv.everyN.week", "{price} every {n} weeks", "每 {n} 周 {price}"],
  ["tv.everyN.month", "{price} every {n} months", "每 {n} 个月 {price}"],
  ["tv.everyN.year", "{price} every {n} years", "每 {n} 年 {price}"],
  ["tv.unit.week", "Week", "周"],
  ["tv.unit.month", "Month", "月"],
  ["tv.unit.year", "Year", "年"],
  ["tv.empty", "No subscribers yet", "还没有订阅会员"],
  ["tv.empty.sub", "Create a plan, then sell it at the POS or let customers sign up on your website.", "先创建订阅计划，然后在收银台销售，或让顾客在网站上自助订阅。"],
  ["tv.plan.new", "New plan", "新建计划"],
  ["tv.plan.empty", "No plans yet", "还没有订阅计划"],
  ["tv.plan.emptySub", "e.g. 4 washes a month for a fixed monthly price, or a VIP membership.", "例如：每月固定价格 4 次洗发，或 VIP 会员月费。"],
  ["tv.f.name", "Plan name", "计划名称"],
  ["tv.f.namePh", "e.g. Wash Club — 4 washes a month", "例如：洗护会员 —— 每月 4 次"],
  ["tv.f.desc", "Description (shown to customers)", "描述（顾客可见）"],
  ["tv.f.price", "Price per period", "每期价格"],
  ["tv.f.interval", "Billed every", "扣款周期"],
  ["tv.f.count", "Every how many", "间隔"],
  ["tv.f.grants", "Each paid period gives the customer", "每期付款后顾客获得"],
  ["tv.g.credits", "Service credits", "服务次数"],
  ["tv.g.package", "A package", "配套"],
  ["tv.g.membership", "Membership tier", "会员等级"],
  ["tv.g.stored_value", "Stored value", "储值"],
  ["tv.g.credits.help", "e.g. 4 × Wash — redeemed at the POS like package sessions.", "例如 4 次洗发 —— 在收银台像配套次数一样核销。"],
  ["tv.g.package.help", "Issues one of your packages every period.", "每期发放一个你现有的配套。"],
  ["tv.g.membership.help", "Keeps the customer on a membership tier (with its discounts) while subscribed.", "订阅期间顾客保持该会员等级（享受相应折扣）。"],
  ["tv.g.stored_value.help", "Tops up the customer's stored value every period (more than the price = bonus).", "每期为顾客储值（高于价格的部分为赠送）。"],
  ["tv.f.sessions", "Sessions per period", "每期次数"],
  ["tv.f.label", "Name of the credits", "次数名称"],
  ["tv.f.services", "Usable on", "适用服务"],
  ["tv.f.anyService", "Any service", "任意服务"],
  ["tv.f.addPool", "Add another kind of credit", "添加另一种次数"],
  ["tv.f.package", "Package", "配套"],
  ["tv.f.tier", "Membership tier", "会员等级"],
  ["tv.f.tierAlso", "Also keep the customer on a membership tier (optional)", "同时给予会员等级（可选）"],
  ["tv.f.none", "None", "无"],
  ["tv.f.storedValue", "Stored value added each period", "每期储值金额"],
  ["tv.rules", "Rules", "规则"],
  ["tv.f.rollover", "Unused credits", "未用完的次数"],
  ["tv.ro.none", "Expire at the end of the period", "本期结束时失效"],
  ["tv.ro.one_cycle", "Roll over one period", "可顺延一期"],
  ["tv.ro.unlimited", "Never expire", "永不过期"],
  ["tv.f.commitment", "Minimum commitment (periods)", "最短订阅期（期数）"],
  ["tv.f.notice", "Cancellation notice (days)", "取消需提前（天）"],
  ["tv.f.trial", "Free trial (days)", "免费试用（天）"],
  ["tv.f.signupFee", "Sign-up fee (one-time)", "开通费（一次性）"],
  ["tv.f.commission", "Seller commission", "销售提成"],
  ["tv.cm.none", "No commission", "不计提成"],
  ["tv.cm.first_cycle", "First payment only", "仅首期"],
  ["tv.cm.every_cycle", "Every payment", "每期"],
  ["tv.f.commissionHelp", "Uses your package-sale commission rules (Team → Commission).", "按“配套销售”提成规则计算（团队 → 提成）。"],
  ["tv.f.memberCancel", "Customers can cancel online (the rules above apply)", "顾客可在会员中心自行取消（遵守以上规则）"],
  ["tv.f.active", "On sale", "在售"],
  ["tv.f.online", "Customers can sign up on your website", "顾客可在网站上自助订阅"],
  ["tv.f.onlineNeedsWebsite", "Online sign-up needs the Website system add-on (included in Full).", "网站自助订阅需要“网站系统”扩展功能（全功能版已包含）。"],
  ["tv.f.branches", "Branches", "分店"],
  ["tv.f.branchesHelp", "None selected = all branches.", "不选 = 所有分店。"],
  ["tv.plan.saved", "Plan saved", "计划已保存"],
  ["tv.plan.inactive", "not on sale", "停售"],
  ["tv.plan.online", "Website", "网站可订"],
  ["tv.plan.subs", "{n} subscribers", "{n} 位订阅"],
  ["tv.plan.snapshot", "Changes apply to new subscribers; existing subscribers keep the terms they signed up with.", "修改只对新订阅生效；已有订阅保持签约时的条款。"],
  ["tv.plan.monthly", "≈ {amount} / month", "≈ 每月 {amount}"],
  ["tv.sell.customer", "Customer", "顾客"],
  ["tv.sell.search", "Search name or phone", "搜索姓名或电话"],
  ["tv.sell.plan", "Plan", "计划"],
  ["tv.sell.start", "Create payment link", "生成付款链接"],
  ["tv.sell.scan", "Ask the customer to scan this with their phone and enter their card. Stripe then bills them automatically every period.", "请顾客用手机扫码并输入银行卡，之后 Stripe 每期自动扣款。"],
  ["tv.sell.copy", "Copy link", "复制链接"],
  ["tv.sell.copied", "Link copied", "链接已复制"],
  ["tv.sell.waiting", "Waiting for the customer… this updates by itself.", "等待顾客完成…会自动更新。"],
  ["tv.sell.done", "Subscription active — first payment received.", "订阅已生效 —— 已收到首期付款。"],
  ["tv.sell.notReady", "Connect Stripe (Settings → Payments) to sell subscriptions — the customer's card is billed by Stripe.", "请先连接 Stripe（设置 → 收款）才能销售订阅 —— 顾客的银行卡由 Stripe 扣款。"],
  ["tv.sell.noPlans", "No plans on sale yet.", "暂无在售计划。"],
  ["tv.sell.trial", "{n}-day free trial", "{n} 天免费试用"],
  ["tv.sell.fee", "+ {amount} sign-up fee", "+ 开通费 {amount}"],
  ["tv.sell.commit", "Minimum {n} periods", "最短 {n} 期"],
  ["tv.sell.demoPay", "Demo: complete the customer's payment", "演示：模拟顾客完成付款"],
  ["tv.d.title", "Subscription", "订阅"],
  ["tv.d.since", "Since {date}", "开始于 {date}"],
  ["tv.d.next", "Next billing {date}", "下次扣款 {date}"],
  ["tv.d.ends", "Ends {date}", "结束于 {date}"],
  ["tv.d.trialEnds", "Trial until {date}", "试用至 {date}"],
  ["tv.d.cycles", "{n} payments", "已付 {n} 期"],
  ["tv.d.invoices", "Payments", "付款记录"],
  ["tv.inv.paid", "Paid", "已付"],
  ["tv.inv.failed", "Failed", "失败"],
  ["tv.inv.open", "Open", "待付"],
  ["tv.inv.void", "Void", "作废"],
  ["tv.inv.uncollectible", "Uncollectible", "无法收取"],
  ["tv.d.retry", "Stripe retries {date}", "Stripe 将于 {date} 重试"],
  ["tv.d.cancel", "Cancel subscription", "取消订阅"],
  ["tv.d.cancelNow", "End immediately", "立即结束"],
  ["tv.d.cancelTitle", "Cancel this subscription?", "取消该订阅？"],
  ["tv.d.cancelBody", "Billing stops after the subscription runs until {date} (shop rules: notice period / minimum commitment).", "订阅将持续到 {date} 后停止扣款（门店规则：提前通知 / 最短期限）。"],
  ["tv.d.cancelNowBody", "Ends now and stops billing. No refund is made automatically.", "立即结束并停止扣款，不会自动退款。"],
  ["tv.d.resume", "Keep subscription", "恢复订阅"],
  ["tv.d.cardUpdate", "Update card", "更新银行卡"],
  ["tv.d.cardScan", "Ask the customer to scan and enter their new card.", "请顾客扫码并输入新银行卡。"],
  ["tv.d.checkout", "Payment link", "付款链接"],
  ["tv.d.demo", "Demo: run billing cycle now", "演示：立即执行扣款周期"],
  ["tv.d.demoFail", "Demo: simulate a declined card", "演示：模拟扣款失败"],
  ["tv.d.demoHint", "Test mode only — does what Stripe does at the end of the period (renew, retry or end).", "仅测试模式 —— 模拟 Stripe 在周期结束时的操作（续费、重试或结束）。"],
  ["tv.d.cancelled", "The subscription will end {date}", "订阅将于 {date} 结束"],
  ["tv.d.reason", "Reason (optional)", "原因（可选）"],
  ["tv.d.order", "Sale {label}", "销售单 {label}"],
  ["tv.r.mrr", "MRR", "月经常性收入 (MRR)"],
  ["tv.r.mrrHint", "Monthly recurring revenue of paying subscribers", "付费订阅每月经常性收入"],
  ["tv.r.active", "Active subscribers", "活跃订阅"],
  ["tv.r.trialing", "{n} in trial", "{n} 位试用中"],
  ["tv.r.churn", "Churn", "流失率"],
  ["tv.r.churnN", "{n} ended", "{n} 位结束"],
  ["tv.r.revenue", "Collected", "已收款"],
  ["tv.r.failed", "Failed payments", "扣款失败"],
  ["tv.r.new", "{n} new", "新增 {n}"],
  ["tv.r.upcoming", "Upcoming renewals", "即将续费"],
  ["tv.r.failing", "Payment failed — Stripe is retrying", "扣款失败 —— Stripe 正在重试"],
  ["tv.r.ending", "Ending", "即将结束"],
  ["tv.r.byPlan", "By plan", "按计划"],
  ["tv.r.none", "Nothing here.", "暂无。"],
  ["tv.r.hint", "Subscription payments are recorded as sales paid by Stripe, so they appear in daily close and the sales reports; credits granted are package liabilities until used.", "订阅付款记为 Stripe 收款的销售，因此会出现在日结与销售报表中；发放的次数在使用前计为配套负债。"],
  ["tv.cust.empty", "No subscriptions.", "暂无订阅。"],
  ["tv.pos.sell", "Subscription", "订阅"],
  ["tv.fake", "Test mode: card payments are simulated.", "测试模式：银行卡付款为模拟。"],
  ["cust.tab.subscriptions", "Subscriptions", "订阅"],
] as const;

export type TvKey = (typeof ROWS)[number][0];
const col = (i: 1 | 2) => Object.fromEntries(ROWS.map((r) => [r[0], r[i]])) as Record<TvKey, string>;

export const taskV = { en: col(1), zh: col(2), ms: col(1) };
